export enum AutomationTriggerType {
  CandidateMoved = 'candidate_moved',
  CandidateDisqualified = 'candidate_disqualified',
  CandidateOverdue = 'candidate_overdue',
  CandidateEvaluationStatusChanged = 'candidate_evaluation_status_changed',
  JobStatusChanged = 'offer_status_changed',
  JobOpeningsFilled = 'offer_openings_filled',
}

export type AutomationTrigger =
  | CandidateMovedTrigger
  | CandidateDisqualifiedTrigger
  | CandidateOverdueTrigger
  | CandidateEvaluationStatusChangedTrigger
  | JobStatusChangedTrigger
  | JobOpeningsFilledTrigger;

export type AutomationTriggerData =
  | CandidateMovedTriggerData
  | CandidateDisqualifiedTriggerData
  | CandidateEvaluationStatusChangedTriggerData
  | JobStatusChangedTriggerData;

export type CandidateMovedTrigger = {
  type: AutomationTriggerType.CandidateMoved;
  data: CandidateMovedTriggerData;
};

export type CandidateMovedTriggerData = {
  stageId: number;
};

export type CandidateDisqualifiedTrigger = {
  type: AutomationTriggerType.CandidateDisqualified;
  data: CandidateDisqualifiedTriggerData;
};

export type CandidateDisqualifiedTriggerData = {
  disqualifyReasonId: number;
};

export type CandidateOverdueTrigger = {
  type: AutomationTriggerType.CandidateOverdue;
  data: null;
};

export type CandidateEvaluationStatusChangedTrigger = {
  type: AutomationTriggerType.CandidateEvaluationStatusChanged;
  data: CandidateEvaluationStatusChangedTriggerData;
};

export type CandidateEvaluationStatusChangedTriggerData = {
  status: string;
};

export type JobStatusChangedTrigger = {
  type: AutomationTriggerType.JobStatusChanged;
  data: JobStatusChangedTriggerData;
};

export type JobStatusChangedTriggerData = {
  status: string;
};

export type JobOpeningsFilledTrigger = {
  type: AutomationTriggerType.JobOpeningsFilled;
  data: null;
};
